var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 11.2812C2.625 11.3516 2.625 11.4219 2.67188 11.4922L3.25781 12.3359C3.32812 12.4531 3.44531 12.5 3.5625 12.5H5.41406C5.53125 12.5 5.64844 12.4531 5.71875 12.3359L6.30469 11.4922C6.32812 11.4219 6.35156 11.3516 6.35156 11.2812V10.25H2.625V11.2812ZM4.5 8C4.89844 8 5.25 7.67188 5.25 7.25C5.25 6.85156 4.89844 6.5 4.5 6.5C4.07812 6.5 3.75 6.85156 3.75 7.25C3.75 7.67188 4.07812 8 4.5 8ZM4.5 0.5C2.08594 0.5 0.375 2.44531 0.375 4.625C0.375 5.67969 0.75 6.61719 1.38281 7.34375C1.78125 7.78906 2.39062 8.72656 2.60156 9.5H3.72656C3.72656 9.40625 3.72656 9.28906 3.67969 9.17188C3.5625 8.75 3.16406 7.67188 2.22656 6.61719C1.75781 6.05469 1.5 5.35156 1.5 4.625C1.47656 2.91406 2.88281 1.625 4.5 1.625C6.14062 1.625 7.5 2.98438 7.5 4.625C7.5 5.35156 7.21875 6.05469 6.75 6.61719C5.83594 7.64844 5.41406 8.75 5.29688 9.17188C5.25 9.28906 5.25 9.38281 5.25 9.5H6.375C6.58594 8.72656 7.19531 7.78906 7.59375 7.34375C8.22656 6.61719 8.625 5.67969 8.625 4.625C8.625 2.35156 6.77344 0.5 4.5 0.5ZM4.26562 5.75H4.71094C4.89844 5.75 5.0625 5.60938 5.08594 5.42188L5.39062 3.17188C5.41406 2.96094 5.22656 2.75 5.01562 2.75H3.96094C3.75 2.75 3.5625 2.96094 3.58594 3.17188L3.89062 5.42188C3.91406 5.60938 4.07812 5.75 4.26562 5.75Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.70b73e83b873c3937557eb6b54ce0bc3.svg";
export { ForwardRef as ReactComponent };